










































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Intro from '@/views/document/group/Intro.vue';
import CustomIntro from '@/views/document/group/CustomIntro.vue';
import CustomOutro from '@/views/document/group/CustomOutro.vue';
import CashflowMethod from '@/views/document/group/CashflowMethod.vue';
import CashflowAnalysis from '@/views/document/group/CashflowAnalysis.vue';
import Profitloss from '@/views/document/group/Profitloss.vue';
import Balance from '@/views/document/group/Balance.vue';
import Cashflow from '@/views/document/group/Cashflow.vue';
import Compass from '@/views/document/group/Compass.vue';
import Yearend from '@/views/document/group/Yearend.vue';
import Competition from '@/views/document/group/Competition.vue';
import GTAdvisory from '@/views/document/group/GTAdvisory.vue';
import Completion from '@/views/document/group/Completion.vue';
import CustomList from '@/views/document/group/CustomList.vue';
import TypedList from '@/views/document/group/TypedList.vue';
import CustomImage from '@/views/document/group/CustomImage.vue';
import Company from '@/views/document/group/Company.vue';
import Sustainability from '@/views/document/group/Sustainability.vue';
import IndustryAnalysis from '@/views/document/group/IndustryAnalysis.vue';
import CompetitorAnalysis from '@/views/document/group/CompetitorAnalysis.vue';
import AnalysisSummary from '@/views/document/group/AnalysisSummary.vue';
import AnalysisNextStep from '@/views/document/group/AnalysisNextStep.vue';
import AnalysisInfo from '@/views/document/group/AnalysisInfo.vue';
import dokument from '@/store/modules/dokument';
import {ImageSection, ListSection} from '@/store/models';
import Schedule from '@/views/document/group/Schedule.vue';
import PreClosingMeetingThisYear from '@/views/document/group/PreClosingMeetingThisYear.vue';
import PreClosingMeetingRemaining from '@/views/document/group/PreClosingMeetingRemaining.vue';
import PreClosingMeetingMisc from '@/views/document/group/PreClosingMeetingMisc.vue';

@Component({
  components: {
    PreClosingMeetingMisc,
    PreClosingMeetingRemaining,
    PreClosingMeetingThisYear,
    Schedule,
    AnalysisInfo,
    AnalysisNextStep,
    AnalysisSummary,
    CompetitorAnalysis,
    IndustryAnalysis,
    Sustainability,
    Company,
    CustomImage,
    CustomList,
    Completion,
    GTAdvisory,
    Competition,
    Compass,
    Yearend,
    Cashflow,
    Balance,
    Profitloss,
    Intro,
    CustomIntro,
    CustomOutro,
    CashflowMethod,
    CashflowAnalysis,
    TypedList,
  },
})
export default class GroupEditor extends Vue {
  @Prop() readonly group!: any;
  @Prop() readonly index!: number;
  @Prop() readonly documentType!: string;

  showTooltip: boolean = false;

  @Watch('index', { immediate: true, deep: true })
  onData() {
    // this.showTooltip = false;
  }

  get title() {
    switch (this.group.Type) {
      case 'intro':
        return 'Inledning';
      case 'schedule':
        return 'Tidsplan';
      case 'profitloss':
        return 'Resultaträkning';
      case 'balance':
        return 'Balansräkning';
      case 'custom_intro':
        return 'Lägg till egen introduktion (valfritt)';
      case 'custom_outro':
        return 'Lägg till egen avslutning (valfritt)';
      case 'cashflow_method':
        return 'Metodik';
      case 'cashflow_analysis':
        return 'Analys';
      case 'cashflow':
        return 'Kassaflödesanalys';
      case 'yearend':
        return 'Bokslut';
      case 'compass':
        return 'Bolagskompass';
      case 'competition':
        return 'Konkurrentjämförelse';
      case 'gtAdvisory':
        return 'Vår rådgivning';
      case 'completion':
        return 'Avslutning';
      case 'preClosingMeeting_thisYear':
        return 'Året hittills';
      case 'preClosingMeeting_remaining':
        return 'Helårsprognos';
      case 'preClosingMeeting_future':
        return 'Ägarplanering';
      case 'preClosingMeeting_schedule':
        return 'Tidsplan';
      case 'preClosingMeeting_misc':
        return 'Övrigt';
      case 'preClosingMeeting_intro':
        return 'Agenda';
      case 'preClosingMeeting_feedback':
        return 'Feedback';
      case 'preClosingMeeting_nextMeeting':
        return 'Nästa möte';

      case 'custom_list':
        const customList = dokument.getItems(this.group.Id)[0] as ListSection;
        if (customList.Title) {
          return customList.Title + ' (Egen lista)';
        } else {
          return 'Egen lista';
        }
      case 'custom_image':
        const customImage = dokument.getItems(this.group.Id)[0] as ImageSection;
        if (customImage.Title) {
          return customImage.Title + ' (Egen bild)';
        } else {
          return 'Egen bild';
        }
      case 'company':
        return 'Huvudinnehåll';

      case 'sustainability':
        return 'Hållbarhet';

      case 'industryAnalysis':
      case 'competitorAnalysis':
        return 'Konsultintryck';

      case 'analysis_summary': return 'Summering';
      case 'analysis_nextstep': return 'Nästa steg';
      case 'analysis_info': return 'Mötesinformation';

      case 'webreport_cashflow': return 'Kommentar';

      default:
        return '';
    }
  }

  get type() {
    return this.group.Type;
  }

  get open() {
    switch (this.group.Type) {
      case 'cashflow_method':
      case 'cashflow_analysis':
      case 'company':
      case 'industryAnalysis':
      case 'competitorAnalysis':
      case 'webreport_cashflow':
      case 'preClosingMeeting_thisYear':
      case 'preClosingMeeting_remaining':
      case 'preClosingMeeting_schedule':
      case 'preClosingMeeting_misc':
        return true;
      default:
        return false;
    }
  }

  get fixedDocument() {
    switch (this.group.Type) {
      case 'industryAnalysis':
      case 'competitorAnalysis':
      case 'analysis_summary':
      case 'analysis_nextstep':
      case 'analysis_info':
      case 'webreport_cashflow':
        return true;
    }
    return false;
  }

  get hidden() {
    switch (this.group.Type) {
      case 'industryAnalysis':
      case 'competitorAnalysis':
        return dokument.getItem(500).Hidden;
      case 'analysis_summary':
        return dokument.getItem(701).Hidden;
      case 'analysis_nextstep':
        return dokument.getItem(711).Hidden;
      case 'analysis_info': return dokument.getItem(720).Hidden;
    }
    return this.group.Hidden;
  }

  get draggable(): boolean {
    switch (this.group.Type) {
      case 'intro':
      case 'completion':
      case 'industryAnalysis':
      case 'competitorAnalysis':
      case 'analysis_summary':
      case 'analysis_nextstep':
      case 'analysis_info':
      case 'webreport_cashflow':
      case 'preClosingMeeting_intro':
      case 'preClosingMeeting_thisYear':
      case 'preClosingMeeting_remaining':
      case 'preClosingMeeting_future':
      case 'preClosingMeeting_schedule':
      case 'preClosingMeeting_misc':
      case 'preClosingMeeting_feedback':
      case 'preClosingMeeting_nextMeeting':
        return false;
      default:
        return true;
    }
  }
  get isLocked(): boolean {
    switch (this.group.Type) {
      case 'intro':
      case 'completion':
        return true;
      default:
        return false;
    }
  }
}
